import { render, staticRenderFns } from "./createCampaignFooter.vue?vue&type=template&id=3b88d3cb&"
import script from "./createCampaignFooter.vue?vue&type=script&lang=js&"
export * from "./createCampaignFooter.vue?vue&type=script&lang=js&"
import style0 from "./createCampaignFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports